export default {
    WorkorderType: {
      Workorderservicetype:'工单类型',
      Addwork: '添加工单类型',
      table: {
        WorkorderText: '工单类型代码',
        ServiceType: '服务',
        TypeErrordescription: '工单类型描述',
        Feeitems:"收费项",
        attachments: '是否需要附件',
        InquiryType: '部门',
        Updatetime: '更新时间',
        Updateperson: '更新人',
      },
    },
    workOrderList:{
        TicketInformation: '工单信息',
        step1: '提交',
        step2: '批准',
        step3: '审核',
        step4: '确认',
        WOTitle:'工单标题',
        Urgent:'紧急程度',
        WOSubmit:'提交审核',
        Approval:'审批',
        Start:'开始处理',
        Pause:'暂停处理',
        Complete:'完成处理',
        to:'作废',
        Confirm:'确认收费',
        processor:'重新指派',
        Modify:'修改客服',
        Number:'工单编号',
        service:'服务',
        title:'标题',
        Description:'工单服务描述',
        type:'处理类型',
        quantity:'处理数量',
        state:'状态',
        Do:'是否暂停',
        Creation:'创建时间',
        Review:'审核时间',
        editTime:'修改预计时间',
        Completion:'完成时间',
        CompletionTime:'预计完成时间',
        Submit:'工单',
        Processing:'处理人',
        Work:'工单描述',
        enclosure:'附件',
        Related:'关联工单信息',
        bar:'条形码',
        results:'处理结果',
        Ticket:'工单回复',
        findings:'审核结果',
        Reason:'审核不通过原因',
        Total:'总工时(分钟)',
        Fee:'收费列表',
        Operations:'处理部门',
        Customer:'客服',
        Operator:'操作人',
        timeS:'预计开始时间',
        timeE:'预计结束时间',
        typeTitle:'相关类型',
        auditTitle:'部门审批',
        customerTitle:'客服确认',
        Comments:'留言框',
        DepartmentText:'指定部门',
    }
  };
  